// extracted by mini-css-extract-plugin
export default {"userDetailsPanel":"UserDetailsPanelComponent_userDetailsPanel__X9fMB","container":"UserDetailsPanelComponent_container__cO3ju"};